import { getDateOfBirth, getGender } from '~/services/pesel/pesel'
import { pesel } from '~/utils/formValidators/pesel'
import { isNullish } from '~/utils/Utils'

export const getAllFieldsFromSchema = (schema) => {
  return Object.values(schema.sections).reduce((acc, section) => {
    acc = { ...acc, ...section.elements }
    return acc
  }, {})
}

export default {
  govId (model, schema) {
    const fields = getAllFieldsFromSchema(schema)
    const isValidPesel = pesel.validate(model.govId)

    if (isValidPesel) {
      model.dateOfBirth = getDateOfBirth(model.govId)
      model.gender = getGender(model.govId)
    } else if (model.govId !== null) {
      model.dateOfBirth = fields.dateOfBirth.defaultValue ?? ''
      model.gender = fields.gender.defaultValue ?? null
    }

    fields.dateOfBirth.disabled = isNullish(fields.dateOfBirth.defaultValue) ? isValidPesel : true
    fields.gender.disabled = fields.gender.defaultValue ? true : isValidPesel
  },

  isChildOrForeigner (model, schema) {
    const fields = getAllFieldsFromSchema(schema)
    const isValidPesel = pesel.validate(model.govId)

    if (!model.isForeigner && !model.isChild && isValidPesel) {
      model.dateOfBirth = getDateOfBirth(model.govId)
      model.gender = getGender(model.govId)
    } else if (model.govId !== null) {
      model.dateOfBirth = fields.dateOfBirth.defaultValue ?? ''
      model.gender = fields.gender.defaultValue ?? null
    }

    fields.dateOfBirth.disabled = isNullish(fields.dateOfBirth.defaultValue)
      ? !model.isForeigner && !model.isChild && isValidPesel
      : true

    fields.gender.disabled = fields.gender.defaultValue
      ? true
      : !model.isForeigner && !model.isChild && isValidPesel
  },

  isOtherAddress (model) {
    model.mailingApartmentNumber = model.isOtherAddress ? '' : model.addressApartmentNumber
    model.mailingCity = model.isOtherAddress ? '' : model.addressCity
    model.mailingHouseNumber = model.isOtherAddress ? '' : model.addressHouseNumber
    model.mailingPostcode = model.isOtherAddress ? '' : model.addressPostcode
    model.mailingStreet = model.isOtherAddress ? '' : model.addressStreet
  },

  copyFieldDataToInvoice (model) {
    const fields = [
      'firstname',
      'lastname',
      'addressApartmentNumber',
      'addressCity',
      'addressHouseNumber',
      'addressPostcode',
      'addressStreet',
    ]

    if (model.invoiceType === 'isPerson' && fields.every(field => !model[`${field}Invoice`])) {
      fields.forEach((field) => {
        model[`${field}Invoice`] = model[field]
      })
    }
  },
}
